import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  LogOut, Sparkles, Image as ImageIcon, FileText, MessageSquare,
  Calendar, Gift, Settings, Users,
} from 'lucide-react';

import FlashManager from './admin/FlashManager';
import PortfolioManager from './admin/PortfolioManager';
import ArtistsManager from './admin/ArtistsManager';
import BlogManager from './admin/BlogManager';
import TestimonialsManager from './admin/TestimonialsManager';
import QuotesManager from './admin/QuotesManager';
import AppointmentsManager from './admin/AppointmentsManager';
import GiftCardsManager from './admin/GiftCardsManager';
import ContentManager from './admin/ContentManager';

const TABS = [
  { id: 'artists', label: 'Artists', icon: Users, Component: ArtistsManager },
  { id: 'flash', label: 'Flash Gallery', icon: Sparkles, Component: FlashManager },
  { id: 'portfolio', label: 'Tattoo Gallery', icon: ImageIcon, Component: PortfolioManager },
  { id: 'blog', label: 'Blog Posts', icon: FileText, Component: BlogManager },
  { id: 'testimonials', label: 'Testimonials', icon: MessageSquare, Component: TestimonialsManager },
  { id: 'quotes', label: 'Quote Requests', icon: FileText, Component: QuotesManager },
  { id: 'appointments', label: 'Appointments', icon: Calendar, Component: AppointmentsManager },
  { id: 'giftcards', label: 'Gift Cards', icon: Gift, Component: GiftCardsManager },
  { id: 'content', label: 'Site Content', icon: Settings, Component: ContentManager },
];

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_c2d28a08-ae0d-49cc-b72b-7be69e3b538c/artifacts/daj5mwbp_IMG_3269.png';

const AdminDashboardPage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('artists');

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (!token) navigate('/admin/login');
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    navigate('/admin/login');
  };

  const ActiveComponent = TABS.find((t) => t.id === activeTab)?.Component || ArtistsManager;

  return (
    <div className="min-h-screen bg-[#F8F8F5]" data-testid="admin-dashboard">
      <header className="bg-black text-white px-6 py-4">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-4">
            <img src={LOGO_URL} alt="Vision Tattoo" className="h-12 w-auto" />
            <div>
              <h1 className="font-heading text-xl font-bold">Vision Tattoo</h1>
              <p className="font-mono text-xs text-gray-400">Admin Dashboard</p>
            </div>
          </div>
          <button
            onClick={handleLogout}
            data-testid="admin-logout-btn"
            className="flex items-center gap-2 bg-white/10 hover:bg-white/20 px-4 py-2 rounded transition-colors"
          >
            <LogOut size={18} />
            <span className="font-mono text-sm">Logout</span>
          </button>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="flex flex-wrap gap-2 mb-8 border-b border-gray-200 pb-4">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              data-testid={`tab-${tab.id}`}
              className={`flex items-center gap-2 px-4 py-2 font-mono text-xs uppercase tracking-wider transition-all ${
                activeTab === tab.id
                  ? 'bg-black text-white'
                  : 'bg-white border border-gray-300 hover:border-black'
              }`}
            >
              <tab.icon size={16} />
              {tab.label}
            </button>
          ))}
        </div>

        <ActiveComponent />
      </div>
    </div>
  );
};

export default AdminDashboardPage;
